// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.G5zZbvmyS8LOJwfEFlfe {
  display: flex;
  align-items: center;
  background: var(--token-bg-inner, #1a1a1a);
  border-radius: 4px;
  padding: 2px 8px 2px 4px;
  cursor: default;
  user-select: none;
  transition: all 0.2s ease;
}
.G5zZbvmyS8LOJwfEFlfe.ejVLSy0ISGLbzIGc8Vct {
  cursor: pointer;
}
.G5zZbvmyS8LOJwfEFlfe.ejVLSy0ISGLbzIGc8Vct:hover {
  background: var(--token-bg-hover, #2a2a2a);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.G5zZbvmyS8LOJwfEFlfe.zB5d5jv7l4LLh5e7Npcp {
  cursor: inherit;
  background: rgba(0, 0, 0, 0.15);
  padding: 2px 4px;
  gap: 2px;
}
.G5zZbvmyS8LOJwfEFlfe.zB5d5jv7l4LLh5e7Npcp .Qwezp788_1zfkHWCZEKz {
  margin-right: 0;
}
.G5zZbvmyS8LOJwfEFlfe.zB5d5jv7l4LLh5e7Npcp ._SAf9Ohmkk5E6hW1rQaJ {
  margin-left: 0;
  margin-right: 0;
  color: var(--token-text, #ffffff);
  opacity: 0.9;
}
.G5zZbvmyS8LOJwfEFlfe.mNbPJpte2Q3sydjGhjXK .Qwezp788_1zfkHWCZEKz {
  width: 0.8rem;
  height: 0.8rem;
}
.G5zZbvmyS8LOJwfEFlfe.mNbPJpte2Q3sydjGhjXK .VruIRXt3SDW5_qhpv1Jz {
  font-size: 0.75rem;
  font-weight: 600;
  color: inherit;
}

.Qwezp788_1zfkHWCZEKz {
  width: 20px;
  height: 20px;
  margin-right: 4px;
  display: inline-block;
  vertical-align: middle;
  pointer-events: none;
}

._SAf9Ohmkk5E6hW1rQaJ {
  color: var(--token-text-muted, #6b7280);
  margin-right: 4px;
}

.VruIRXt3SDW5_qhpv1Jz {
  font-size: 16px;
  font-weight: 500;
  color: var(--token-text, #ffffff);
}

.jPc4awVjot1NlLb_R0HT {
  margin-left: 8px;
  font-size: 14px;
  color: var(--token-text, #ffffff);
}

/* Container wrapper for ProfileModal usage */
.k2TWfodb9ZszKwVnHOdu {
  background: var(--token-bg-outer, #2a2a2a);
  border: 1px solid var(--token-border, #404040);
  border-radius: 6px;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  margin-top: 8px;
}`, "",{"version":3,"sources":["webpack://./src/shared/auth/components/TokenDisplay.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,kBAAA;EACA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;AACF;AAEE;EACE,eAAA;AAAJ;AAEI;EACE,0CAAA;EACA,2BAAA;EACA,wCAAA;AAAN;AAKE;EACE,eAAA;EACA,+BAAA;EACA,gBAAA;EACA,QAAA;AAHJ;AAKI;EACE,eAAA;AAHN;AAMI;EACE,cAAA;EACA,eAAA;EACA,iCAAA;EACA,YAAA;AAJN;AAUI;EACE,aAAA;EACA,cAAA;AARN;AAWI;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;AATN;;AAcA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;EACA,oBAAA;AAXF;;AAcA;EACE,uCAAA;EACA,iBAAA;AAXF;;AAcA;EACE,eAAA;EACA,gBAAA;EACA,iCAAA;AAXF;;AAcA;EACE,gBAAA;EACA,eAAA;EACA,iCAAA;AAXF;;AAcA,6CAAA;AACA;EACE,0CAAA;EACA,8CAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAXF","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tokenDisplay": `G5zZbvmyS8LOJwfEFlfe`,
	"hoverable": `ejVLSy0ISGLbzIGc8Vct`,
	"inline": `zB5d5jv7l4LLh5e7Npcp`,
	"tokenIcon": `Qwezp788_1zfkHWCZEKz`,
	"multiplier": `_SAf9Ohmkk5E6hW1rQaJ`,
	"compact": `mNbPJpte2Q3sydjGhjXK`,
	"count": `VruIRXt3SDW5_qhpv1Jz`,
	"label": `jPc4awVjot1NlLb_R0HT`,
	"tokenContainer": `k2TWfodb9ZszKwVnHOdu`
};
export default ___CSS_LOADER_EXPORT___;
